import MiniSearch from 'minisearch'
import autoComplete from "@tarekraafat/autocomplete.js";

let searchIndexJson = undefined;
let searchIndex = undefined;
// An array of [downcased title, stored_fields]
let manualTitleIndex = undefined;

async function fetchSearchIndexJson() {
  for (let i=0; i < 5; i++) {
    try {
      let response = await fetch('/docs/' + document.documentElement.lang + '/search-index.json')
      if (!response.ok) {
        continue
      }

      searchIndexJson = await response.text()
      return
    } catch(e) {
      // Basically sleeping before we retry
      throw e
      await new Promise(r => setTimeout(r, 1000));
    }
  }
  throw "Couldn't load search index"
}

function buildSearchIndex() {
  if (searchIndex) {
    return
  }

  searchOptions = {
    fields: ['title', 'content'],
    searchOptions: {
      boost: { title: 1.2 },
      tokenize: (string, _fieldName) => string.split(/[^_\p{L}@]+/u),
      processTerm: (term) =>
        term.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase(),
    }
  }

  searchIndex = MiniSearch.loadJSON(searchIndexJson, searchOptions);
  window.searchIndex = searchIndex

  manualTitleIndex = [];
  for (let entry of searchIndex._storedFields) {
    manualTitleIndex.push([entry[1].title.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase(), entry[1]])
  }
}

fetchSearchIndexJson()

// Javascript compares arrays by first joining, and comparing the string...
// https://stackoverflow.com/questions/8328908/javascript-surprising-array-comparison
function compareArrays(a, b) {
  var elA, elB, i, len;
  for (i = 0, len = Math.min(a.length, b.length); i < len; i++) {
    elA = a[i], elB = b[i];
    if (elA > elB) return 1;
    if (elA < elB) return -1;
  }
  return b.length - a.length;
};

function search(query) {
  buildSearchIndex()

  query = query.trim().normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase()

  if (query.length < 2) {
    if (query.length == 0 || /\p{L}/u.test(query)) {
      // We allow single character queries for symbols only
      return []
    }
  }

  let choices = []

  let regexp = new RegExp(query.replace(/([^a-zA-Z0-9])/g, "\\$1").split(/(\\ )+/).join(".*"))

  for (let entry of manualTitleIndex) {
    if (regexp.test(entry[0])) {
      choices.push(entry[1])
    }
  }

  if (choices.length) {
    // Sorting by length then case insensitive title
    const keyFunction = fields => [fields.title.length, fields.title.toLowerCase(), fields.title];
    const choicesWithKeys = choices.map(item => ([keyFunction(item), item]));
    window.choicesWithKeys = choicesWithKeys
    choicesWithKeys.sort((a, b) => compareArrays(a[0], b[0]));
    choices = choicesWithKeys.map(entry => entry[1]);
  }

  let possibleResults = searchIndex.search(query, {
    prefix: true,
  })

  possibleResults = possibleResults.filter((item) => {
    return !choices.some((choice) => item.title == choice.title)
  })

  return choices.concat(possibleResults)
}

document.addEventListener("turbo:load", function () {
  const autoCompleteJS = new autoComplete({
    data: {
        src: async (query) => {
          const results = search(query);
          return results.slice(0, 10);
        },
        keys: ["title"],
    },
    events: {
      input: {
        blur: () => autoCompleteJS.close(),
        focus: () => {
          if (autoCompleteJS.input.value != "" && autoCompleteJS.list.childElementCount > 0) {
            autoCompleteJS.open()
          }
        }
      },
    },
    resultsList: {
      maxResults: 15,
      element: () => { setTimeout(() => { autoCompleteJS.next() }, 0)}
    },
    selector: "#searchbox",
    searchEngine: (q, record) => { return record },
    wrapper: false,
  });

  window.current_autoCompleteJS = autoCompleteJS

  let searchBox = document.querySelector("#searchbox");

  searchBox.addEventListener("selection", function (event) {
    Turbo.visit(event.detail.selection.value.path)
  });

  searchBox.addEventListener("keydown", function (event) {
    if (event.key === "Tab" && autoCompleteJS.list.childElementCount > 0) {
      if (event.shiftKey) {
        autoCompleteJS.previous()
      } else {
        autoCompleteJS.next()
      }
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  });

  searchBox.addEventListener("mousedown", function (event) {
    // TODO: Ignore touch events
    if (document.activeElement == searchBox || searchBox.value != "") {
      return
    }
    if (Math.random() >= 0.2) {
      return
    }
    document.querySelector("#searchbox-hint").classList.remove("hidden")
  });
})

const skippedKeys = new Set([
  "Control", "Shift", "Alt", "Meta",
  "ArrowLeft", "ArrowUp", "ArrowRight", "ArrowDown",
  "Home", "End", "PageDown", "PageUp", "Tab",
  "Dead",
  "F1", "F2", "F3", "F4", "F5", "F6", "F7", "F8", "F9", "F10", "F11", "F12",
  "CapsLock", "NumLock", "ScrollLock",
  "Insert", "Escape", " "])

window.addEventListener("keydown", event => {
  // console.log(event.key)

  let searchBox = document.querySelector("#searchbox")
  if (document.activeElement == searchBox) {
    return
  }
  if (skippedKeys.has(event.key)) {
    return
  }
  if (event.ctrlKey && event.key != 'v') {
    // The only Ctrl-shortcut we want to focus is a paste.
    return
  }

  searchBox.focus()
  if (event.key == "Enter") {
    // Making sure this doesn't accidentally go to a result if it wasn't focused
    event.preventDefault()
    event.stopImmediatePropagation()
  }
}, {capture: true});
